<div class="input-field" [ngClass]="wrapperClass">
  <app-unities-dropdown
    *ngIf="quantity && formName && id"
    [show]="dropdownVisible"
    [quantity]="quantity"
    [formName]="formName"
    [id]="id"
    (selected)="setFieldUnit($event)"
  >
  </app-unities-dropdown>

  <label *ngIf="!!outsideIcon" for="{{ id }}">
    <i class="input-field-icon-outside {{ outsideIcon }}" (click)="emitOutsideIconClick()"></i>
  </label>

  <label *ngIf="!quantity && label && !small" for="{{ id }}" class="input-field-label">
    <span class="input-field-label-border-left" [ngClass]="{ highlighted: highlighted }"></span>
    <span class="input-field-label-content" [innerHTML]="getLabel()"></span>
    <span class="input-field-label-border-right" [ngClass]="{ highlighted: highlighted }"></span>
  </label>

  <p *ngIf="quantity && formName && label && !small" class="input-field-label">
    <span class="input-field-label-border-left" [ngClass]="{ highlighted: highlighted }"></span>
    <span
      class="input-field-label-content"
      (click)="dropdownVisible = !dropdownVisible"
      (clickOutside)="dropdownVisible = false"
      [innerHTML]="getLabel()"
    >
    </span>
    <span class="input-field-label-border-right" [ngClass]="{ highlighted: highlighted }"></span>
  </p>

  <div class="input-field-wrapper">
    <input
      class="input-field-element"
      [ngClass]="{ highlighted: highlighted }"
      [type]="type"
      [id]="id"
      [name]="name"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (input)="onChange()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keyup.enter)="onBlur()"
      [attr.maxlength]="maxlength"
      [readonly]="readonly"
      [title]="readonly ? title || 'This is a read only field' : title || ''"
      #fieldElement
    />

    <i
      *ngIf="!!insideIcon"
      class="input-field-icon-inside {{ insideIcon }}"
      (click)="emitInsideIconClick()"
    ></i>
  </div>

  <div class="input-field-messages-wrapper">
    <ng-content #fieldMessages select="[fieldMessages]"></ng-content>
  </div>
</div>
